import React from 'react'
import './todolist.css' 

export const Footer = () => {
  return (
    <React.Fragment>
       <footer>
        <section className="footer"> 
        <p>UI credit: <a href="https://kadettodowithvue.netlify.app/" target="_blank">Kadet</a></p>
        <p>Todolist</p>
        </section>
    </footer>
        </React.Fragment>
  )
}